<template>
  <div>
    <h2>{{player.name}}</h2>
    <div class="dl-box">
      <div>{{player.fullname}}</div>
    </div>
    <template>
      <div
        class="dl-box"
        v-for="inn in [1, 2, 'superover']"
        v-if="played(inn)"
        :key="inn"
      >
        <template v-if="match.batting_order.length > 2">
          <br/>
          <h3>
            <span v-if="inn != 'superover'">Innings {{inn}}</span>
            <span v-else>Super Over</span>
          </h3>
        </template>
        <div
          v-for="key in statsGroups"
          v-if="shouldShowStats(inn, key)"
          :key="key"
          >
          <div class="name">{{key | capitalise}}<span
          v-if="key === 'batting' && !player.match.innings[inn].batting.dismissed">*</span></div>
          <div v-if="key === 'batting'">
            <div><span class="changing">{{batString(inn)}}</span></div>
            <div
              v-if="player.match.innings[inn].batting.dismissed"
              @click="onBallSelected(player.match.innings[inn].batting.ball_of_dismissed)"
              >
              <div class="silent">{{player.match.innings[inn].batting.out_str}}</div>
              <div class="silent clickable">FOW: {{dismissedAtString(inn)}}</div>
            </div>
            <br/>
          </div>
          <div v-if="key === 'bowling'">
            <div><span class="changing">{{bowlString(inn)}}</span></div>
            <br/>
          </div>

          <dl>
            <template v-for="prop in statsKeys(inn, key)">
              <dt>{{prop | capitalise}}</dt>
              <dd>{{player.match.innings[inn][key][prop]}}</dd>
            </template>
          </dl>
        </div>
      </div>
    </template>

    <div class="dl-box">
      <div class="name" v-if="player.role && player.role.key">{{player.role.key | capitalise}}</div>
      <dl>
        <dt>Can bat</dt>
        <dd>{{(player.identified_roles.batsman)? 'Yes': 'No'}}</dd>
        <dt>Can bowl</dt>
        <dd>{{(player.identified_roles.bowler)? 'Yes': 'No'}}</dd>
        <dt>Can keep</dt>
        <dd>{{(player.identified_roles.keeper)? 'Yes': 'No'}}</dd>
        <dt>Seasonal Role</dt>
        <dd>{{player.seasonal_role | capitalise('-')}}</dd>
      </dl>
    </div>

    <div class="dl-box">
      <div class="name"></div>
      <div v-if="!hideStats">
        <router-link 
                class="box" 
                :to="{name: 'cricketPlayer', params:{key: player.key}}">Player Stats</router-link>
      </div>
      <div
        class="boxes compact width30"
        v-if="appState.fantasy.showEdit"
      >
        <fantasy-add-to-team-button
          :playerKey="player.key"
          addText="Add to My Fantasy Team"
        ></fantasy-add-to-team-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      statsGroups: ['batting', 'bowling', 'fielding'],
      ignores: {
        'batting': ['dismissed', 'dismissed_at', 'out_str', 'ball_of_dismissed']
      }
    }
  },
  props: {
    match: Object,
    player: Object,
    hideStats: Boolean
  },
  methods: {

    batString (inn) {
      const bat = this.player.match.innings[inn].batting
      return `${bat.runs}(${bat.balls}) ${bat.fours}x4s ${bat.sixes}x6s`
    },

    bowlString (inn) {
      const bowl = this.player.match.innings[inn].bowling
      return `${bowl.wickets}/${bowl.overs} (${bowl.economy} ecom)`
    },

    dismissedAtString (inn) {
      const dismissed = this.player.match.innings[inn].batting.dismissed_at
      return `${dismissed.team_runs}/${dismissed.wicket_index} (${dismissed.over - 1}.${dismissed.ball} ov)`
    },

    statsKeys (inn, key) {
      let keys = Object.keys(this.player.match.innings[inn][key])
      const ignoreProbs = (this.ignores[key]) ? this.ignores[key] : []
      keys = keys.filter(x => ignoreProbs.indexOf(x) == -1)
      return keys
    },

    shouldShowStats (inn, key) {
      let keys = this.statsKeys(inn, key)
      return keys.length > 1
    },

    played (inn) {
      if (this.match.status.isNotStarted) {
        return false
      }

      if (!this.player.match.innings[inn]) {
        return false
      }

      for (let i = 0; i < this.statsGroups.length; i++) {
        if (this.shouldShowStats(inn, this.statsGroups[i])) {
          return true
        }
      }
      return false
    },

    onBallSelected (ball) {
      this.$emit('ballSelected', ball)
    }
  }
}
</script>
